import type { Tomo } from '../types/content';
export const tomos: Tomo[] = [{
  numero: '01',
  emoji: '⏱️',
  nombre: 'El Cronómetro de Oro',
  descripcion: 'Dominá tus tiempos y terminá con las jornadas eternas. Incluye protocolos de limpieza express y cálculo de tiempos reales para maximizar tu agenda sin agotarte.',
  meta: 'Checklists de velocidad incluidos',
  imagen: 'https://cdn.magicpatterns.com/uploads/dHZAMKAu3oAPJNNCr2eQu2/mega_pack_tomo_01_transparente_(1).png'
}, {
  numero: '02',
  emoji: '💵',
  nombre: 'El Menú de Diseños “Cash”',
  descripcion: "Diseños de Alta Conversión: Los que más piden y menos tiempo te llevan.\nMatriz de Complejidad: El sistema exacto para saber cuánto cobrar.\nScripts de Venta: Cómo guiar a tu clienta hacia los diseños que a vos te dan más ganancia.",
  meta: 'Diseños listos incluidos',
  imagen: 'https://cdn.magicpatterns.com/uploads/xsjjJR2XaVmxVHecPovjJ5/mega_pack_tomo_02_transparente.png'
}, {
  numero: '03',
  emoji: '🧘‍♀️',
  nombre: 'El Escudo Anti-Reclamos',
  descripcion: 'Protegé tu paz y tu bolsillo. Fichas médicas, contratos de servicio y política de retoques. Poné límites claros de horario y cobrá cada extra sin entrar en conflicto.',
  meta: 'Fichas y contratos incluidos',
  imagen: 'https://cdn.magicpatterns.com/uploads/qVH5eUH7QYA3YptFbErPk6/mega_pack_tomo_03_transparente_2.png'
}, {
  numero: '04',
  emoji: '📈',
  nombre: 'La Máquina de Ganancia Real',
  descripcion: 'Dejá de trabajar a pérdida. Calculá en 10 minutos tu costo por servicio y tu ganancia neta por hora. Incluye el guion exacto para actualizar tus tarifas con autoridad y seguridad.',
  meta: 'Matriz de precios LATAM incluida',
  imagen: 'https://cdn.magicpatterns.com/uploads/jje9QrCP2FyoJ7Waa1SLxW/mega_pack_tomo_04_transparente_real_(1)_(1).png'
}, {
  numero: '05',
  emoji: '💎',
  nombre: 'Imán de Clientas Premium',
  descripcion: 'Atraé al público que sí paga lo que valés. 30 días de contenido listo para publicar y el paso a paso para convertir seguidoras en citas confirmadas, sin perseguir a nadie.',
  meta: 'Contenido listo para copiar',
  imagen: 'https://cdn.magicpatterns.com/uploads/mP53JBLFhmDrfmuEevTUrp/mega_pack_tomo_05_transparente_real.png'
}, {
  numero: '06',
  emoji: '🧰',
  nombre: 'El Botiquín de Crisis',
  descripcion: 'Diagnóstico rápido de problemas técnicos, manejo de roturas y reacciones, recuperación de una clienta molesta y protocolos de higiene y seguridad.',
  meta: 'Protocolos de higiene incluidos',
  imagen: 'https://cdn.magicpatterns.com/uploads/6REdQSRuecFGx1p4fQjNQb/mega_pack_tomo_06_transparente.png'
}];
export const incluyeCadaTomo: string[] = ['Guías prácticas listas para usar hoy', 'Scripts y textos que funcionan', 'Checklists de trabajo diario', 'Matrices de precios adaptadas a tu país', 'Protocolos profesionales documentados', 'Respuestas para situaciones difíciles', 'Lenguaje que funciona en toda LATAM', 'Diseños, calendarios y recursos visuales'];